module.exports = __webpack_public_path__ + "graphics/checkout-flow-individual.ckh.78595a8ad7474e6a33c9e9f03e4a16ac.svg";